<template>
  <header>
    <nav>
      <div class="logo">Feed Lead</div>
      <div class="nav-links">
        <a href="#features">Features</a>
        <a href="#benefits">Benefits</a>
        <a href="#pricing">Pricing</a>
        <a href="#contact" class="cta-button">Request Demo</a>
      </div>
      <button :class="['mobile-menu-btn', { 'is-active': isMenuOpen }]" @click="toggleMenu" aria-label="Toggle menu">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </nav>
    <!-- Mobile menu overlay -->
    <div :class="['mobile-menu-overlay', { 'is-active': isMenuOpen }]" @click="toggleMenu"></div>
    <!-- Mobile menu -->
    <div :class="['mobile-menu', { 'is-active': isMenuOpen }]">
      <div class="mobile-menu-content">
        <div class="mobile-menu-header">
          <div class="logo">Feed Lead</div>
        </div>
        <div class="mobile-menu-links">
          <a href="#features" @click="toggleMenu">
            <span class="icon">⚡</span>
            Features
          </a>
          <a href="#benefits" @click="toggleMenu">
            <span class="icon">✨</span>
            Benefits
          </a>
          <a href="#pricing" @click="toggleMenu">
            <span class="icon">💎</span>
            Pricing
          </a>
          <a href="#contact" class="cta-button" @click="toggleMenu">
            <span class="icon">🚀</span>
            Request Demo
          </a>
        </div>
        <div class="mobile-menu-footer">
          <div class="social-links">
            <a href="#" class="social-link">Twitter</a>
            <a href="#" class="social-link">LinkedIn</a>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'TheHeader',
  data() {
    return {
      isMenuOpen: false
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    }
  }
}
</script>

<style scoped>
header {
  padding: 1rem 2rem;
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: fixed;
  width: 100%;
  z-index: 100;
}

nav {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--primary-color);
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.nav-links a {
  text-decoration: none;
  color: var(--text-color);
  font-weight: 500;
}

.cta-button {
  padding: 0.5rem 1rem;
  background: var(--primary-color);
  color: white !important;
  border-radius: var(--border-radius);
}

.mobile-menu-btn {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 21px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 100;
}

.mobile-menu-btn span {
  width: 100%;
  height: 3px;
  background: var(--primary-color);
  border-radius: 3px;
  transition: all 0.3s ease;
}

.mobile-menu-btn.is-active span {
  background: var(--primary-color);
}

.mobile-menu-btn.is-active span:nth-child(1) {
  transform: translateY(9px) rotate(45deg);
}

.mobile-menu-btn.is-active span:nth-child(2) {
  opacity: 0;
}

.mobile-menu-btn.is-active span:nth-child(3) {
  transform: translateY(-9px) rotate(-45deg);
}

.mobile-menu-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  opacity: 0;
  transition: opacity 0.3s ease;
  backdrop-filter: blur(4px);
  z-index: 90;
}

.mobile-menu-overlay.is-active {
  opacity: 1;
}

.mobile-menu {
  display: none;
  position: fixed;
  top: 0;
  right: -100%;
  width: 100%;
  height: 100vh;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 95;
}

.mobile-menu.is-active {
  right: 0;
}

.mobile-menu-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 1rem;
}

.mobile-menu-header {
  padding: 1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  margin-bottom: 2rem;
}

.mobile-menu-links {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0 1rem;
}

.mobile-menu-links a {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  font-size: 1.25rem;
  color: var(--text-color);
  text-decoration: none;
  border-radius: var(--border-radius);
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.mobile-menu-links a:hover {
  transform: translateX(5px);
  background: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.mobile-menu-links .icon {
  font-size: 1.5rem;
}

.mobile-menu-links .cta-button {
  margin-top: 1rem;
  background: var(--primary-color);
  color: white;
  font-weight: 600;
}

.mobile-menu-footer {
  padding: 2rem 1rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.social-links {
  display: flex;
  justify-content: center;
  gap: 2rem;
}

.social-link {
  color: var(--text-color);
  text-decoration: none;
  font-size: 0.9rem;
  opacity: 0.7;
  transition: opacity 0.3s ease;
}

.social-link:hover {
  opacity: 1;
}

@media (max-width: 768px) {
  .nav-links {
    display: none;
  }

  .mobile-menu-btn {
    display: flex;
  }

  .mobile-menu,
  .mobile-menu-overlay {
    display: block;
  }

  .mobile-menu.is-active {
    right: 0;
  }

  .mobile-menu-overlay.is-active {
    opacity: 1;
  }
}
</style> 